export default "__VITE_ASSET__9J5fun3z__"